import { useLocation } from 'react-router-dom'
import { missionAt } from '@/content/missions'
import HomePage from './HomePage'
import NotFoundPage from './NotFoundPage'

/** The home page at a mission's own address, such as /cbp. */
export default function MissionHomePage() {
  return missionAt(useLocation().pathname) ? <HomePage /> : <NotFoundPage />
}
